import { PunctualityReportRepository } from '@src/main/modules/reports/punctuality/domain/punctuality-report.repository';

export const downloadPunctualityReportPdf = async (
  repository: PunctualityReportRepository,
  formId: string,
): Promise<Blob> => await repository.downloadPdf(formId);
